module.exports = __webpack_public_path__ + "vyhlazeni-vrasek-metodou-derma-k_4_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/vyhlazeni-vrasek-metodou-derma-k_4_before_tn.jpg
// module id = 1724
// module chunks = 0